<template>
    <div>
        <el-row id="logo_image_wrapper" v-loading="!facilityLogoUrl">
            <img v-show="facilityLogoUrl" id="logo_image" :src="facilityLogoUrl">
        </el-row>

        <SelectSlotToOrderBooking ref="selectSlotToOrderBooking" @setFacilityLogoUrl="setFacilityLogoUrl"
                                  @redirectConfirmDisplayToPay="redirectConfirmDisplayToPay"></SelectSlotToOrderBooking>
        <ConfirmToPay ref="confirmToPay" @redirectPayAndCreateBooking="redirectPayAndCreateBooking"
                      @backSelectOrderSlot="backSelectOrderSlot"></ConfirmToPay>
        <PayAndCreateBooking ref="payAndCreateBooking" @pay="payBooking"
                             @redirectCompleteBooking="redirectCompleteBooking"
                             @backConfirmToPay="backConfirmToPay"></PayAndCreateBooking>
        <CompleteBooking ref="completeBooking" @redirectToBookingPage="backToDefault"></CompleteBooking>
    </div>
</template>

<script>
    import BookingApi from "../../api/booking/BookingApi";
    import SelectSlotToOrderBooking from "./components/SelectSlotToOrderBooking";
    import ConfirmToPay from "./components/ConfirmToPay";
    import PayAndCreateBooking from "./components/PayAndCreateBooking";
    import CompleteBooking from "./components/CompleteBooking";
    import AlertService from "../../service/alert.service";
    import Pages from "@/router/Pages";

    export default {
        name: "BookingOrder",
        components: {
            CompleteBooking,
            PayAndCreateBooking,
            SelectSlotToOrderBooking,
            ConfirmToPay,
        },

        data() {
            return {
                bookingDto: null,
                facilityLogoUrl: "",
                loadingImage: false
            }
        },

        mounted() {
           this.backToDefault();
        },

        methods: {
            redirectConfirmDisplayToPay(bookingOrderDto) {
                console.log("Set booking order dto...");
                console.log(bookingOrderDto)
                this.$refs["confirmToPay"].setBookingOrder(bookingOrderDto);
                this.$refs["confirmToPay"].show();
                this.$refs["selectSlotToOrderBooking"].hide();
            },

            setFacilityLogoUrl(facilityLogoUrl) {
                console.log("Logo url:");
                console.log(facilityLogoUrl);
                this.facilityLogoUrl = facilityLogoUrl;
            },

            redirectPayAndCreateBooking(bookingDto, totalFee) {
                if (totalFee !== 0) {
                    this.$refs["confirmToPay"].hide();
                    this.$refs["payAndCreateBooking"].redirectToPayAndCreateBooking(bookingDto, totalFee);
                } else {
                    this.$refs["confirmToPay"].enableLoading();
                    this.payBooking("", bookingDto);
                }
            },

            redirectCompleteBooking(bookingNumber) {
                this.$refs["confirmToPay"].hide();
                this.$refs["payAndCreateBooking"].hide();
                this.$refs["completeBooking"].show();
                this.$refs["completeBooking"].setBookingNumber(bookingNumber);
            },

            backSelectOrderSlot() {
                this.$refs["confirmToPay"].hide();
                this.$refs["selectSlotToOrderBooking"].show();
            },

            backConfirmToPay() {
                this.$refs["confirmToPay"].show();
                this.$refs["payAndCreateBooking"].hide();
            },

            backToDefault() {
              this.$refs["selectSlotToOrderBooking"].show();
              this.$refs["confirmToPay"].hide();
              this.$refs["payAndCreateBooking"].hide();
              this.$refs["completeBooking"].hide();
            },

            payBooking(token, bookingDto) {
                let createBookingDto = {
                    booking: bookingDto,
                    bookingPaymentInfo: {
                        token: token
                    },
                };

                let timeRangeCustoms = createBookingDto.booking.bookingTimeRange.bookingTimeRangeCustoms;
                for (let i = 0 ; i < timeRangeCustoms.length; i++) {
                    let dateWasReformatted = timeRangeCustoms[i].date.split("-").join("/");
                    timeRangeCustoms[i].date = dateWasReformatted;
                }
                createBookingDto.booking.bookingTimeRange.bookingTimeRangeCustoms = timeRangeCustoms;


                BookingApi.createBooking(createBookingDto).then(result => {
                    console.log("Result: ", result);

                    if (result.status.message == "SUCCESS") {
                        //redirect to complete booking display
                        console.log("test");
                        this.redirectCompleteBooking(result.data.bookingNumber);
                    } else {
                        const message = {
                            "EXCEED_LIMIT_BOOKING_SLOT": "bookingOrder.bookingNotEnoughSlot",
                            "EXCEED_LIMIT_USE_COUPON": "bookingOrder.runOutOfSlots",
                            "PAYMENT_FAIL": "bookingOrder.paymentFailed",
                        }

                        AlertService.error(this.$t(message[result.status.errorType]));
                        this.$refs["confirmToPay"].disableLoading();
                        this.$refs["payAndCreateBooking"].disableLoading();
                    }
                }).catch(e => {
                    console.log(e);
                    AlertService.error(this.$t("common.serverErrorMessage"));
                    this.$refs["confirmToPay"].disableLoading();
                    this.$refs["payAndCreateBooking"].disableLoading();
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    #logo_image {
        width: 200px;
        height: 60px
    }

    #logo_image_wrapper {
        text-align: center
    }

    @media only screen and (max-width: 450px) {
        #logo_image_wrapper {
            text-align: center;

            #logo_image {
                width: 60%;
                height: 60px
            }
        }
    }

</style>